import { defaultApi, defaultClient } from '@mint-sdk/api-core';

import {
  GetFilterOptionsMdmResponseSchema,
  GetFilterOptionsQuerySchema,
  GetFilterOptionsRequestSchema,
  GetFilterOptionsRequestSchemaMdm,
  GetFilterOptionsResponseSchema,
} from '../shared/schemas/filterOptions.js';

export type {
  FilterParams,
  MdmFilterParams,
  MdmFilterValue,
  TextFilterConditionType,
  NumberFilterConditionType,
  GetFilterOptionsResponse,
  GetFilterOptionsMdmResponse,
  MdmFilterOptionsAdditional,
} from '../shared/schemas/filterOptions.js';
export const getFilterOptions = defaultApi.declareEndpoint({
  url: 'planning-service/virtuals/placement-folders/filter-options/',
  method: 'POST',
  requestSchema: GetFilterOptionsRequestSchema,
  responseSchema: GetFilterOptionsResponseSchema,
});

export const getFilterOptionsQueryOptions = defaultClient.query({
  url: 'planning-service/virtuals/placement-folders/filter-options/',
  method: 'POST',
  requestSchema: GetFilterOptionsRequestSchema,
  responseSchema: GetFilterOptionsResponseSchema,
  querySchema: GetFilterOptionsQuerySchema,
});

export const getFilterOptionsMdm = defaultApi.declareEndpoint({
  url: 'planning-service/virtuals/placement-folders/filter-options-v2/',
  method: 'POST',
  requestSchema: GetFilterOptionsRequestSchemaMdm,
  responseSchema: GetFilterOptionsMdmResponseSchema,
});

export const getFilterOptionsMdmQueryOptions = defaultClient.query({
  url: 'planning-service/virtuals/placement-folders/filter-options-v2/',
  method: 'POST',
  requestSchema: GetFilterOptionsRequestSchemaMdm,
  responseSchema: GetFilterOptionsMdmResponseSchema,
  querySchema: GetFilterOptionsQuerySchema,
});
